
  import React from "react"
  import Component from "C:/Users/markl/Projects/simple-gatsby-site/src/layouts/index.jsx"
  import data from "C:\\Users\\markl\\Projects\\simple-gatsby-site\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js